export const TRACKING_RUN_REQUESTED_AT_KEY = 'aees:tracking-run-requested-at';
export const TRACKING_RUN_ACCEPTED_KEY = 'aees:tracking-run-accepted-key';

export const trackingRunKeyFromStartedAt = (startedAt: unknown): string => (
  typeof startedAt === 'number' && Number.isFinite(startedAt)
    ? `run:${startedAt.toFixed(3)}`
    : 'idle'
);

export const trackingRunKeyFromStatus = (status: any): string => (
  trackingRunKeyFromStartedAt(status?.diagnostics?.started_at_wall)
);

export const markTrackingRunRequested = (): number => {
  const requestedAt = Date.now() / 1000;
  window.localStorage.setItem(TRACKING_RUN_REQUESTED_AT_KEY, String(requestedAt));
  window.localStorage.removeItem(TRACKING_RUN_ACCEPTED_KEY);
  window.dispatchEvent(new CustomEvent('aees:tracking-run-requested', { detail: { requestedAt } }));
  return requestedAt;
};

export const markTrackingRunAccepted = (runKey: string) => {
  if (!runKey || runKey === 'idle') return;
  window.localStorage.setItem(TRACKING_RUN_ACCEPTED_KEY, runKey);
};

export const markTrackingRunFailed = (requestedAt?: number) => {
  const current = Number(window.localStorage.getItem(TRACKING_RUN_REQUESTED_AT_KEY));
  if (requestedAt == null || !Number.isFinite(current) || Math.abs(current - requestedAt) < 0.001) {
    window.localStorage.removeItem(TRACKING_RUN_REQUESTED_AT_KEY);
    window.localStorage.removeItem(TRACKING_RUN_ACCEPTED_KEY);
  }
};

export const shouldUseTrackingRun = (status: any): boolean => {
  const runKey = trackingRunKeyFromStatus(status);
  if (runKey === 'idle') return false;

  if (window.localStorage.getItem(TRACKING_RUN_ACCEPTED_KEY) === runKey) {
    return true;
  }

  const requestedAt = Number(window.localStorage.getItem(TRACKING_RUN_REQUESTED_AT_KEY));
  const startedAt = Number(status?.diagnostics?.started_at_wall);
  if (Number.isFinite(requestedAt) && Number.isFinite(startedAt) && startedAt >= requestedAt - 30) {
    markTrackingRunAccepted(runKey);
    return true;
  }

  const outputCount = Number(status?.diagnostics?.output_count ?? 0);
  const latestTimestamp = Number(status?.latest_output?.timestamp);
  const hasServerOutput = outputCount > 0 || Number.isFinite(latestTimestamp);
  const requestIsNewerThanRun = Number.isFinite(requestedAt)
    && Number.isFinite(startedAt)
    && requestedAt > startedAt + 30;
  if (hasServerOutput && !requestIsNewerThanRun) {
    markTrackingRunAccepted(runKey);
    return true;
  }

  return false;
};

export const isTrackingRunRequestPending = (status: any): boolean => {
  const requestedAt = Number(window.localStorage.getItem(TRACKING_RUN_REQUESTED_AT_KEY));
  if (!Number.isFinite(requestedAt)) return false;
  const startedAt = Number(status?.diagnostics?.started_at_wall);
  return !Number.isFinite(startedAt) || requestedAt > startedAt + 30;
};
